export default __webpack_public_path__ + "static/media/wide_modded_minecraft.f4dceda9.jpg";